<template>
	<v-container grid-list-lg>
		<v-layout row wrap>		
			<v-flex lg12 class="userInfo">
				<div class="historyBox" v-for="history in rfcHistory">
					<table width="100%">
						<tr>
							<td><strong>NEW STATUS:</strong></td>
							<td>{{ history.new_value }}</td>
						</tr>
						<tr>
							<td><strong>PREVIOUS STATUS:</strong></td></td>
							<td>{{ history.prev_value }}</td>
						</tr>
						<tr>
							<td><strong>DATE CHANGED:</strong></td>
							<td>{{ history.timestamp }}</td>
						</tr>
						<tr>
							<td><strong>CHANGED BY:</strong></td>
							<td>{{ history.name }}</td>
						</tr>
						<tr>
							<td><strong>COMMENTS:</strong></td>
							<td>{{ fncCheckComment(history.data) }}</td>
						</tr>
					</table>
				</div>
			</v-flex>
          <div class="pl-4 pr-1 pb-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>              
            </div>
          </div>		
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncCheckComment(comment) {
			    if( comment === '' ) {
					return 'No Comment';
				} else {
			    	return comment;
				}
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',					
				'globalModalParams',
				'rfcHistory'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>